import { Circle, VStack, Text } from '@chakra-ui/react'
import { AIParadigm, paradigmIcons } from '../../stores/agentStore'

interface AgentIconProps {
  name: string
  status: 'active' | 'inactive'
  paradigm: AIParadigm
  onClick: () => void
}

export const AgentIcon = ({ name, status, paradigm, onClick }: AgentIconProps) => {
  const Icon = paradigmIcons[paradigm]

  return (
    <VStack 
      as="button"
      onClick={onClick}
      spacing={2}
      align="center"
      _hover={{ opacity: 0.8 }}
    >
      <Circle 
        size="100px" 
        bg={status === 'active' ? 'blue.100' : 'gray.100'}
        border="2px"
        borderColor={status === 'active' ? 'blue.500' : 'gray.400'}
      >
        <Icon size={40} color={status === 'active' ? 'blue.500' : 'gray.500'} />
      </Circle>
      <Text>{name}</Text>
    </VStack>
  )
} 